import { useState } from 'react';
import {
    DELETE_CONFIRM_LABEL,
    DELETE_KEEP_LABEL,
    DELETE_REQUEST_LABEL,
    DELETE_WARNING,
    ACTION_BUTTON_CLASSES,
} from '../vacationRequestDetailsModal.definitions';

export interface DeleteRequestActionProps {
    onConfirm: () => void;
    isDeleting: boolean;
    isOpen?: boolean;
    onOpenChange?: (open: boolean) => void;
    showWarning?: boolean;
}

/**
 * Confirmação em duas etapas dentro do próprio modal de histórico: o primeiro clique só revela o
 * aviso, a exclusão em si exige um segundo clique explícito — evita apagar uma solicitação por
 * engano num toque de tela.
 */
export function DeleteRequestAction({
    onConfirm,
    isDeleting,
    isOpen: controlledOpen,
    onOpenChange,
    showWarning = true,
}: DeleteRequestActionProps) {
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
    const isOpen = controlledOpen !== undefined ? controlledOpen : uncontrolledOpen;
    const setOpen = (newOpen: boolean) => {
        if (controlledOpen !== undefined) {
            onOpenChange?.(newOpen);
        } else {
            setUncontrolledOpen(newOpen);
        }
    };

    if (!isOpen) {
        return (
            <button
                type="button"
                onClick={() => setOpen(true)}
                className={`rounded-xl border border-red-200 bg-white font-semibold text-red-700 transition-colors hover:bg-red-50 font-montserrat whitespace-nowrap ${ACTION_BUTTON_CLASSES.normal}`}
            >
                {DELETE_REQUEST_LABEL}
            </button>
        );
    }

    return (
        <div className="flex flex-col items-end gap-2 sm:flex-row sm:items-center">
            {showWarning && (
                <p className={`text-red-700 font-montserrat ${ACTION_BUTTON_CLASSES.normalWarning}`}>{DELETE_WARNING}</p>
            )}
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => setOpen(false)}
                    disabled={isDeleting}
                    className={`rounded-xl border border-gray-200 bg-white font-semibold text-raro-gray-700 transition-colors hover:bg-gray-50 font-montserrat whitespace-nowrap ${ACTION_BUTTON_CLASSES.normal}`}
                >
                    {DELETE_KEEP_LABEL}
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={isDeleting}
                    className={`rounded-xl border border-transparent bg-red-600 font-semibold text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60 font-montserrat whitespace-nowrap ${ACTION_BUTTON_CLASSES.normal}`}
                >
                    {DELETE_CONFIRM_LABEL}
                </button>
            </div>
        </div>
    );
}

export default DeleteRequestAction;
